import React from 'react';
import { routes as r } from '../../routes';
import { PendingApprovalRequests } from './PendingApprovalRequests';
import { AllApprovalRequests } from './AllApprovalRequests';

export const routes = () => ({
  pending: {
    route: r.pendingApprovalRequests.route,
    render: () => <PendingApprovalRequests />,
  },
  all: {
    route: r.allApprovalRequests.route,
    render: () => <AllApprovalRequests />,
  },
});
